


/**
 * 北斗map类
 */

import { viewerCfig } from './config'
import { formatNum } from "../analysis/utils/space"
import DrawBase from "../plot/DrawBase"
import registerAllMaterials from '../effect/Materials/index' //注册材质
import createWidgets from '../widget/index' //注册场景部件
import KeyboardRoaming from "../animation/KeyboardRoaming"
import { hasTerrain } from "../analysis/utils/terrain.js"
import {createImageryLayerByBaseMaps,createImageryLayerBybaseTerrain} from "./Layerfactory"
import PlotManage from "@/utils/cesiumBD/plot/PlotManage.js";
class BDMap {

    constructor(cesiumContainer, options) {
        options = options || {};

        // var terrainProvider = new Cesium.CesiumTerrainProvider({
        //     url: 'http://8.222.132.108/dem/20230428GX/dem'
        // });

        // options.terrainProvider=terrainProvider;
        // contextOptions: {
        //     requestWebgl1: true,
        //   }
        this.options = { ...viewerCfig, ...options };
        //this.options.contextOptions = { requestWebgl1: true };
        this.options.terrainProvider=createImageryLayerBybaseTerrain();
        console.log(this.options);
        this.viewer = new Cesium.Viewer(cesiumContainer, this.options);

        registerAllMaterials(Cesium.Material); //注册自定义材质

        /**
        * Registers default widgets
        */
        let widgets = createWidgets()
        Object.keys(widgets).forEach(key => {
            this.use(widgets[key])
        })

        window.viewer = this.viewer;

        this.removeEvent();

        this.drawBase = new DrawBase({
            viewer: viewer,
            Cesium: Cesium
        });
        this.baseMaps = [];
        this.baseMapsObj = {};

        this.baseLayers = [];
        this.baseLayersObj = {};
        if (this.options.terrainProvider) {
            this.terrainProvider = this.options.terrainProvider;
        }


        this.keyboard = new KeyboardRoaming(this.viewer);

        createImageryLayerByBaseMaps(this);
    
        this.plotUti = new PlotManage();
    }

    //添加插件
    use(plugin) {
        if (plugin && plugin.install) {
            plugin.install(this.viewer)
        }
        return this
    }

    //获取地形状态
    getTerrainProviderState() {
        return hasTerrain(this.viewer);
    }

    //设置地形数据状态
    setTerrainVisible(show) {

        if (show) {
            this.viewer.terrainProvider = this.terrainProvider;
            return;
        }
        this.viewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
    }

    //获取底图
    getBasemaps() {
        return this.baseMaps;
    }

    //获取矢量图层
    getLayers() {
        return this.baseLayers;
    }

    //缩放到图层
    zoomToLayer(name) {
        var layer = this.baseLayersObj[name];
        layer && (layer.zoomLayer());
    }
    //设置地图可见性
    setMapVisible(name, show) {
        var layer = this.baseMapsObj[name];
        layer && (layer.show = show);
        if (show && layer) {
            //添加图层
            if (!this.viewer.imageryLayers.contains(layer)) {
                this.viewer.imageryLayers.add(layer);
            }
        }
    }

    setlayerVisible(name, show) {
        var layer = this.baseLayersObj[name];
        layer && (layer.show = show);
    }

    //设置图层可见性
    setLayerVisible(name, type, show) {

        switch (type) {
            case "map":
                this.setMapVisible(name, show);
                break;
            case "terrain":
                this.setTerrainVisible(show);
                break;
            case "layer":
                this.setlayerVisible(name, show);
                break;
            default:
                break;

        }

    }

    //添加特效
    addEffect() {

    }

    //添加图层
    addLayer(layer, name, type) {
        layer.name = name;
        switch (type) {
            case 'map':
                this.addMap(layer, name)
                break;
            case 'features':
                this.addFeatures(layer, name);
                break;

            case 'tileset':
                this.addFeatures(layer, name);
            case 'tilesetLayer':
                this.addFeatures(layer, name);
                break;
            default:
                break;
        }
    }

    addLayerCom(layer) {
        let type = layer.getType();
        let dataSource = layer.getDataSource();
        layer.fire("eventLoaded",{});
        switch (type) {
            case 'geojson':
                this.viewer.dataSources.add(dataSource);
                this.addFeatures(layer, layer.name);
            default:
                break;
        }
    }

    //添加要素
    addFeatures(layer, name) {
        if (!this.baseLayers.includes(layer)) {
            this.baseLayers.push(layer);
            this.baseLayersObj[name] = layer;
        }
    }
    //添加底图
    addMap(layer, name) {
        this.viewer.imageryLayers.add(layer);
        if (!this.baseMaps.includes(layer)) {
            this.baseMaps.push(layer);
            this.baseMapsObj[name] = layer;
        }
    }

    //提取相机视角范围参数 
    getCameraView(viewer) {
        viewer = viewer || window.viewer;
        var camera = viewer.camera;
        var position = camera.positionCartographic;
        var bookmark = {};
        bookmark.y = formatNum(Cesium.Math.toDegrees(position.latitude), 6);
        bookmark.x = formatNum(Cesium.Math.toDegrees(position.longitude), 6);
        bookmark.z = formatNum(position.height, 2);
        bookmark.heading = formatNum(Cesium.Math.toDegrees(camera.heading || -90), 1);
        bookmark.pitch = formatNum(Cesium.Math.toDegrees(camera.pitch || 0), 1);
        bookmark.roll = formatNum(Cesium.Math.toDegrees(camera.roll || 0), 1);
        return bookmark;
    }

    //设置相机位置
    setCameraView(view) {
        var opts = {};
        opts.destination = Cesium.Cartesian3.fromDegrees(view.x, view.y, view.z); //经度、纬度、高度 
        opts.orientation = {
            heading: Cesium.Math.toRadians(Cesium.defaultValue(view.heading, 0)), //绕垂直于地心的轴旋转
            pitch: Cesium.Math.toRadians(Cesium.defaultValue(view.pitch, -90)), //绕纬度线旋转
            roll: Cesium.Math.toRadians(Cesium.defaultValue(view.roll, 0)) //绕经度线旋转
        };
        this.viewer.camera.flyTo(opts);
    }

    //旋转地球
    rotateAnimation(endfun, duration) {
        var viewer = this.viewer;

        var first = this.getCameraView(viewer); //默认为原始视角
        var duration3 = duration / 3;

        //动画 1/3
        viewer.camera.flyTo({
            destination: Cesium.Cartesian3.fromDegrees(first.x + 120, first.y, first.z),
            orientation: {
                heading: Cesium.Math.toRadians(first.heading),
                pitch: Cesium.Math.toRadians(first.pitch),
                roll: Cesium.Math.toRadians(first.roll)
            },
            duration: duration3,
            easingFunction: Cesium.EasingFunction.LINEAR_NONE,
            complete: function complete() {

                //动画 2/3
                viewer.camera.flyTo({
                    destination: Cesium.Cartesian3.fromDegrees(first.x + 240, first.y, first.z),
                    orientation: {
                        heading: Cesium.Math.toRadians(first.heading),
                        pitch: Cesium.Math.toRadians(first.pitch),
                        roll: Cesium.Math.toRadians(first.roll)
                    },
                    duration: duration3,
                    easingFunction: Cesium.EasingFunction.LINEAR_NONE,
                    complete: function complete() {

                        //动画 3/3
                        viewer.camera.flyTo({
                            destination: Cesium.Cartesian3.fromDegrees(first.x, first.y, first.z),
                            orientation: {
                                heading: Cesium.Math.toRadians(first.heading),
                                pitch: Cesium.Math.toRadians(first.pitch),
                                roll: Cesium.Math.toRadians(first.roll)
                            },
                            duration: duration3,
                            easingFunction: Cesium.EasingFunction.LINEAR_NONE,
                            complete: function complete() {
                                if (endfun) endfun();
                            }
                        });
                        //动画3/3 end 
                    }
                });
                //动画2/3 end
            }
        });
        //动画1/3 end
    }

    //去除鼠标默认事件
    removeEvent() {
        viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
    }
    //截图
    //  const dataURL = canvas.toDataURL("image/jpeg",1); //获取Base64编码
    expImage(options) {
        viewer.scene.render();// 渲染一次
        let canvas = viewer.scene.canvas;
        let image_url = canvas.toDataURL('image/png');
        return image_url
    }

    expImageUrl(options) {
        viewer.scene.render();// 渲染一次
        let canvas = viewer.scene.canvas;
        let image_url = canvas.toDataURL('image/png');
        return image_url
    }



}

export default BDMap;